/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-24 15:37:41
 * @Explain: 数据转换,映射
 */
import { DEFAULT_ABBREVIATION_LANGUAGE } from '@/config/defaultConfig';
import type { LanguageType } from '@/definition/common/data.d';
import { setInitialsCap } from '.';
import { getTimeEndOf, getTimeStartOf } from '../format/time';
import { datePattern, onPattern } from '../regular';
import { onInterfaceTimeNew } from './businessLogic';
import {
  isArray,
  isEffectiveValue,
  isEmptyObject,
  isObject,
} from './dataJudgment';

// 把符合条件的数据插到第一位
export const onInsertFirst = (arr: any[], condition: (item: any) => any) => {
  const index = arr.findIndex(condition);
  if (index !== -1) {
    const [item] = arr.splice(index, 1);
    arr.unshift(item);
  }
  return arr;
};
// 生成键值对
export function getKeyValuePairs({
  list,
  key = 'label',
  value = 'value',
}: {
  list: any[];
  key?: string;
  value?: string | 'allData';
}): Record<any, any> {
  const obj: any = {};
  if (isArray(list) && list.length) {
    list.forEach((item: any) => {
      obj[item[key]] = value === 'allData' ? item : item[value];
    });
  }
  return obj;
}

/** 语言字段转换 zh-CN 转 zhCn */
export function convertLangCode(value: LanguageType) {
  try {
    const parts = value.split('-');
    if (parts.length === 2) {
      const [language, region] = parts;

      const _region = region.toLowerCase();
      return `${language}${setInitialsCap(_region)}`;
    }
  } catch (e) {
    console.error('convertLangCode =>>', e);
  }
  return value;
}
// 获取枚举对应语种
export function getEnumLangValue(
  enumObj: Record<any, any>,
  language: string,
  prefix?: string,
): string {
  const defaultLang = DEFAULT_ABBREVIATION_LANGUAGE;
  let value = '';
  if (isObject(enumObj) && language && !isEmptyObject(enumObj)) {
    if (prefix) {
      value = enumObj[prefix + language] || enumObj[prefix + defaultLang];
    } else {
      value = enumObj[language] || enumObj[defaultLang];
    }
  }
  return value;
}

// 转化数据 - 映射输出
export const formatMappingOutput = ({
  mappingOptions,
  mappingObj,
  value,
}: {
  mappingOptions?: any[];
  mappingObj?: any;
  value: any;
}) => {
  let data = null;
  /* 数组对象格式 */
  if (isEffectiveValue(value) && mappingOptions && isArray(mappingOptions)) {
    const map = getKeyValuePairs({
      list: mappingOptions,
      key: 'value',
      value: 'allData',
    });
    data = map[value];
  }

  /* 对象格式 */
  if (isEffectiveValue(value) && mappingObj && mappingObj[value]) {
    data = mappingObj[value];
  }

  return data;
};

// 根据数据类型输出初始值
export const getDefaultValueByType: any = (value?: string) => {
  let val = undefined;
  const type = Object.prototype.toString.call(value);
  switch (type) {
    case '[object String]':
      val = '';
      break;
    case '[object Number]':
      val = 0;
      break;
    case '[object Array]':
      val = [];
      break;
    case '[object Object]':
      val = {};
      break;
  }
  return val;
};

// 过滤无效的参数
export const filterInvalidParameter = (params: any) => {
  return Object.fromEntries(
    Object.entries(params).filter(([key, value]) => isEffectiveValue(value)),
  );
};

/**
 * 判断是否是标准化时间
 * timeOf - start 代表获取当天最早的时间
 * timeOf - end 代表获取当天最晚的时间
 */
export const onJudgeIso86Time = (val: any, timeOf?: 'start' | 'end') => {
  const iso8601DateTime = onPattern(val, datePattern.iso8601DateTime);
  if (iso8601DateTime) {
    return val;
  }
  switch (timeOf) {
    case 'start':
      return onInterfaceTimeNew(getTimeStartOf(val));
    case 'end':
      return onInterfaceTimeNew(getTimeEndOf(val));
    default:
      return onInterfaceTimeNew(val);
  }
};

/** 转换时间范围数组 换对象 */
export const onTimeArrChangeObj = (val: any[]) => {
  const obj = {
    startTime: '',
    endTime: '',
  };
  try {
    if (isArray(val)) {
      obj.startTime = onJudgeIso86Time(val?.[0], 'start');
      obj.endTime = onJudgeIso86Time(val?.[1], 'end');
    }
  } catch (e) {
    console.error('onTimeArrChangeObj', e);
  }
  return obj;
};
